(() => {
  const TEMPLATE_SELECTOR = '#StaygoodCommerceTrustTemplate';
  const PANEL_SELECTOR = '[data-sg-commerce-trust]';
  const DETAILS_SELECTOR = '#MainContent[data-template^="product"] .product-details';

  function mountCommerceTrust() {
    const template = document.querySelector(TEMPLATE_SELECTOR);
    const details = document.querySelector(DETAILS_SELECTOR);

    if (!(template instanceof HTMLTemplateElement) || !details) return;
    if (details.querySelector(PANEL_SELECTOR)) return;

    const fragment = template.content.cloneNode(true);
    const panel = fragment.querySelector(PANEL_SELECTOR);
    if (!(panel instanceof HTMLElement)) return;

    const buyButtons = details.querySelector('.product-form-buttons');
    if (buyButtons) {
      buyButtons.insertAdjacentElement('afterend', panel);
      return;
    }

    const purchaseGroup = details.querySelector('.group-block');
    (purchaseGroup || details).append(panel);
  }

  function start() {
    mountCommerceTrust();
    window.setTimeout(mountCommerceTrust, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(mountCommerceTrust, 50);
  });
})();
